<template>
  <div>
    <div class="banner_img">
      <img :src="this.selectItem.image" alt="" />
    </div>
    <div class="content">
      <div class="banner_Nav">
        <div
          :class="
            selectItem.index == index ? 'navItem navItemSelect' : 'navItem'
          "
          v-for="(item, index) in bannerNavList"
          :key="index"
          @click="changeSelected(item, index)"
        >
          <img
            :src="selectItem.index == index ? $imgUrl.imgUrl(item.icon.split(',')[1]) : $imgUrl.imgUrl(item.icon.split(',')[0])"
            alt=""
          />
          <p>{{ item.title }}</p>
        </div>
      </div>
      <div class="joinCondition">
        <div class="commontitle">
          <div class="text1 text">加盟条件</div>
          <div class="text2 text">Franchise Conditions</div>
        </div>
        <div class="conditionPart">
          <div class="conditionList">
            <div
              class="conditionItem"
              v-for="(item, index) in conditionList"
              :key="index"
            >
              <img :src="$imgUrl.imgUrl(item.image)" alt="" />
              <div class="condition_text1">{{ item.title }}</div>
              <div class="condition_text2">
                <p class="condition_text2_1">{{ item.desc }}</p>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="JoinUs">
        <div class="commontitle">
          <div class="text1 text">诚邀加盟</div>
          <div class="text2 text">Join Us</div>
        </div>
        <div class="JoinUsForm">
          <div class="formsContent">
            <el-form
              :model="formSoftware"
              ref="formSoftware"
              label-width="100px"
            >
              <el-form-item prop="name">
                <span slot="label">
                  <span> 您的姓名</span>
                  <span class="red">*</span>
                </span>
                <el-input
                  v-model="formSoftware.name"
                  placeholder="请输入名字"
                ></el-input>
              </el-form-item>
              <el-form-item prop="phone">
                <span slot="label">
                  <span> 手机号码</span>
                  <span class="red">*</span>
                </span>
                <el-input
                  v-model="formSoftware.phone"
                  placeholder="请输入手机号"
                ></el-input>
              </el-form-item>
              <el-form-item prop="province">
                <span slot="label">
                  <span> 加盟省</span>
                  <span class="red">*</span>
                </span>
                <el-input
                  v-model="formSoftware.province"
                  placeholder="请输入您的意向加盟省份"
                ></el-input>
              </el-form-item>
              <el-form-item prop="city">
                <span slot="label">
                  <span> 加盟市</span>
                  <span class="red">*</span>
                </span>
                <el-input
                  v-model="formSoftware.city"
                  placeholder="请输入您的意向加盟城市"
                ></el-input>
              </el-form-item>
              <el-form-item label="备注说明" prop="remark" class="descrBox">
                <el-input
                  type="textarea"
                  v-model="formSoftware.remark"
                  placeholder="备注说明"
                ></el-input>
              </el-form-item>
              <el-form-item class="clickBtn">
                <el-button class="btn" @click="submitForm('formSoftware')"
                  >立即点击，抢先报名！</el-button
                >
              </el-form-item>
            </el-form>
          </div>
        </div>
        <div class="hotLineCode">
          <div class="hotLine">
            <div class="text">加盟分销、定制合作全国联系热线</div>
            <div class="tel">
              <img src="../../src/img/tel_icon.png" alt="" />
              <p>400-5800-888</p>
            </div>
          </div>
          <div class="hotCode"><!--'../../src/img/wxB.jpg' -->
            <img :src="customWxImg" alt="" />
            <p>稻喜定制官方微信</p>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import * as axios from "../../src/axios/api.js";
import imgUrl from "../../src/utils/imgUrl.js";
export default {
  data() {
    return {
      bannerNavList: [
        
      ],
      selectItem: {
        index: 0,
        image: "",
      },
      customWxImg:'',
      conditionList: [
        
      ],
      formSoftware: {
        name: "",
        phone: "",
        provice: "",
        city: "",
        remark: "",
      },
    };
  },
  created() {
    let id = this.$route.query.id;
    this.getInvestment(id);
    this.catid=id
  },
  methods: {
    changeSelected(item, index) {
      this.selectItem = {
        index: index,
        image: imgUrl.imgUrl(item.pic),
      };
    },
    submitForm() {
      axios.post("/api/join", this.formSoftware).then((res) => {
        if (res.code == 1) {
          this.$message({
            message: res.msg,
            type: "success",
          });
          this.formSoftware={
            name: "",
            phone: "",
            provice: "",
            city: "",
            remark: "",
          }
        }
      });
    },
    getInvestment(catid){
      axios.get("/api/join/info",{catid:catid}).then((res) => {
        if (res.code == 1) {
          var data=res.data
          this.bannerNavList=data.banner
          this.conditionList=data.info.custom
          var that=this
          this.selectItem = {
            index: 0,
            image: imgUrl.imgUrl(that.bannerNavList[0].pic),
          };
          
        }
      });
      axios.post('/api/index/config').then(res => {
          if(res.code==1){
            this.customWxImg=imgUrl.imgUrl(res.data.web_stie_qrcode);
          }
      });
    }
  },
  mounted() {
    
  },
};
</script>

<style scoped>
.banner_img {
  width: 100%;
  height: 800px;
}
.banner_img img {
  width: 100%;
  height: 800px;
  position: relative;
  z-index: -1;
}
.banner_Nav {
  display: flex;
  justify-content: center;
  align-items: center;
  margin-top: -60px;
}
.navItem {
  width: 150px;
  height: 150px;
  background: #ffffff;
  color: #666666;
  font-size: 18px;
  text-align: center;
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
  cursor:pointer;
}
.navItemSelect {
  background: #009144;
  color: #f7f7f7;
}
.navItem img {
  width: 36px;
  height: 36px;
  margin-bottom: 19px;
}

.joinCondition {
  width: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
}
.joinCondition .text2 {
  padding-bottom: 66px;
  box-sizing: border-box;
}
.commontitle {
  width: 100%;
  text-align: center;
  margin-top: 120px;
}
.commontitle .text {
  font-family: Microsoft YaHei;
  font-weight: 400;
  line-height: 42px;
}
.commontitle .text1 {
  font-size: 36px;
  color: #009144;
}
.commontitle .text2 {
  font-size: 16px;
  color: #999999;
}

.conditionPart {
  width: 100%;
  height: 370px;
  background: #f7f7f7;
  padding: 90px 0 89px 0;
  box-sizing: border-box;
}
.conditionList {
  width: 75vw;
  display: flex;
  justify-content: space-around;
  align-items: center;
  /* padding: 0 299px 0 371px; */
  box-sizing: border-box;
  margin:0 auto;
}

.conditionItem {
  width: 340px;
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
  text-align: center;
  /* margin: 0 auto; */
}
.conditionItem img {
  width: 70px;
  height: 70px;
}
.conditionItem .condition_text1 {
  margin: 28px 0 24px 0;
}
.condition_text {
  font-family: Microsoft YaHei;
  font-weight: 400;
}
.condition_text1 {
  color: #333333;
  line-height: 42px;
  font-size: 22px;
}
.condition_text2 {
  font-size: 18px;
  color: #666666;
  line-height: 28px;
}
.JoinUsForm {
  width: 100%;
  background: #ffffff;
  padding: 0 276px;
  box-sizing: border-box;
}
.formsContent {
  background: #ffffff;
  width: 100%;
}
.el-form {
  width: 100%;

  display: flex;
  justify-content: center;
  align-items: center;
  flex-wrap: wrap;
}
.el-form-item__label {
}
/deep/.el-form .el-input__inner {
  width: 23vw !important;
}
/deep/.el-form-item:not(:nth-child(2n)) {
  margin-right: 3.7vw;
}
/deep/.el-textarea__inner {
  width: 55vw;
  height: 100px;
}
/deep/.descrBox {
  margin-right: 0px !important;
}

.red {
  color: #fc2f2f;
}
.btn {
  margin-top: 30px;
  background: #009144;
  font-size: 18px;
  font-family: Microsoft YaHei;
  font-weight: 400;
  color: #fefefe;
  line-height: 42px;
}
/deep/.clickBtn .el-form-item__content {
  margin-left: 0 !important;
}

.hotLineCode {
  width: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  padding-bottom: 90px;
  box-sizing: border-box;
}
.hotLine .text {
  font-size: 30px;
  font-family: Microsoft YaHei;
  font-weight: 400;
  color: #333333;
  line-height: 42px;
}
.hotLine img {
  width: 40px;
  height: 39px;
  margin-right: 35px;
}
.hotLine .tel {
  font-size: 60px;
  font-family: Arial;
  font-weight: bold;
  color: #333333;
  line-height: 42px;
  display: flex;
  margin-top: 33px;
}
.hotCode {
  margin-left: 150px;
  text-align: center;
}
.hotCode img {
  width: 114px;
  height: 113px;
  padding: 8px;
  box-sizing: border-box;
  border: 1px solid #b3b3b3;
}
</style>